import React, { useState } from 'react';
import Sidebar from './Sidebar';
import TopBar from './TopBar';

const AdminLayout = ({ children, fullWidth = false }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="min-h-screen bg-gray-100">
      <div className="flex h-screen overflow-hidden">
        {/* Sidebar */}
        <Sidebar isOpen={sidebarOpen} setIsOpen={setSidebarOpen} />

        {/* Main content */}
        <div className="flex-1 flex flex-col overflow-hidden">
          {/* Top bar */}
          <TopBar toggleSidebar={() => setSidebarOpen(!sidebarOpen)} />

          {/* Page content */}
          <main className="flex-1 overflow-y-auto">
            {fullWidth ? (
              children
            ) : (
              <div className="py-6">
                <div className="w-full px-4 sm:px-6 lg:px-8">
                  {children}
                </div>
              </div>
            )}
          </main>
        </div>
      </div>
    </div>
  );
};

export default AdminLayout;

